import CInput from './Input.vue'

export {
  CInput
}

export default {
  CInput
}
